import { useState, useEffect } from 'react';
import CloseSave from '../../../../design/close';
import ConinerHead from './ContinerHead';
import AppAufaFlight from './AppAufaFlight';
import AppAufaCar from './AppAufaCar';
import { fetchGetAufa } from '../../../../../faetures/fetch';
import sortData from './sortedData';
import './appAufaFlightCar.css';


export default function AppAufaFlightCar({name, setClose, flight, setFlight, setDataMain, setSelectProject, setSettingProject, setProjectId, dataFlightCar, setDataFlightCar, insertFlightCar}) {
    const [flightNumber, setFlightNumber] = useState(1);
    const [carNumber, setCarNumber] = useState(3);
    const [data, setData] = useState({cars: null, flight: {}});
    const [specialFligh, setSpecialFlight] = useState({});

    useEffect(() => {
        let interval;
        fetchGetAufa(`start-project?project=${name}`).then((resolve) => {

            if (typeof resolve === 'object') {
                resolve['project'] && setProjectId(resolve['project']);
                setData({cars: resolve['cars'], flight: resolve['flight']});

                // specail time
                if (resolve['flight'] && resolve['flight']['S']) {
                    const insertspecialTime = {};
                    Object.keys(resolve['flight']['S']).map((value) => {
                        let time = resolve['flight']['S'][value]['time'];
                        time && (insertspecialTime[value] = Math.floor(time / 60));
                    })
                    setSpecialFlight(insertspecialTime);
                    interval = setInterval(() => {
                        setSpecialFlight(specialFligh => {
                            const insertspecialTime = {};
                            Object.keys(specialFligh).map((value) => {
                                insertspecialTime[value] = specialFligh[value] - 1;
                            })
                            return insertspecialTime;
                        });
                    }, 60000)
                }
            }
        })
        return () => clearInterval(interval)
    }, [])

    function clcikContinerHead (num) {
        setFlight(num < 3); // updates if it's a flight or a car
        num < 3 ? setFlightNumber(num + 1) : setCarNumber(num);
    }

    return (<>
    <div className='app-aufa-flight-car main-docket'>
        <div>
            <p> {flight ? 'טיסות' : 'נסיעות פנים'} {name} </p>
            <p onClick={() => setFlight(! flight)}>מעבר ל{flight ? 'נסיעות פנים' : 'טיסות'} </p>
            <CloseSave setClose={() => setClose()} bc='none' c='black' hc='black' hbc='none' bold={'bold'} />
        </div>

        <div>
            <div>
                {[1, 2, 3, 4].map((num) =>
                    <ConinerHead 
                    key={num}
                    num={num}
                    select={dataFlightCar[`${num < 3 ? 'f' : 'c'}${num % 2 === 1 ? 'a' : 'r'}`][1]}
                    onClick={clcikContinerHead}
                    />
                )}

                <div onClick={insertFlightCar}><p> עדכון </p></div>
            </div>
        </div>
        <div>
            { flight ? 
            <AppAufaFlight 
            dataFlightCar={dataFlightCar} 
            setDataFlightCar={setDataFlightCar} 
            number={flightNumber} 
            setNumber={setFlightNumber} 
            data={sortData(data['flight'])} 
            special={specialFligh}
            />
            : 
            <AppAufaCar 
            numberCar={carNumber} 
            setNumberCar={setCarNumber} 
            DataFlightCar={dataFlightCar} 
            setDataFlightCar={setDataFlightCar}
            data={data['cars']} />
            }
        </div>
    </div>
    </>)
}